import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCutlery = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00328 26.6667H12.0033M12.0033 26.6667H16.0033M12.0033 26.6667V20M12.0033 20C12.0033 20 7.33661 17.504 6.00328 14.6667C4.56328 11.604 6.00328 6 6.00328 6H18.0033C18.0033 6 19.4433 11.604 18.0033 14.6667C16.6699 17.504 12.0033 20 12.0033 20ZM22.6699 26.6667V16C22.6699 16 26.0033 14.6667 26.0033 12V6M22.6699 11.3333V6",
		stroke: "black",
		strokeWidth: 2.75862,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCutlery;
